module.exports = __webpack_public_path__ + "img/Zhejiang-power.91ea1a36.png";